import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async (params) => {
  return await dponetAPI.get('/company_favorites', { params })
}

const create = async ({ favoritableId, favoritableType }) => {
  return await dponetAPI.post('/company_favorites', {
    companyFavorite: { favoritableId, favoritableType },
  })
}

const destroy = async ({ companyFavoriteId }) => {
  return await dponetAPI.delete(`/company_favorites/${companyFavoriteId}`)
}

const companyFavorites = {
  get,
  create,
  destroy,
}

export default companyFavorites
